import { __extends } from "tslib";
import { Rectangle, Point } from "@awayjs/core";
import { Filter3DTaskBase } from "./Filter3DTaskBase";
import { ContextGLProgramType } from '../../base/ContextGLProgramType';
var Filter3DCopyPixelTask = /** @class */ (function (_super) {
    __extends(Filter3DCopyPixelTask, _super);
    function Filter3DCopyPixelTask() {
        var _this = _super.call(this) || this;
        _this.rect = new Rectangle();
        _this.destPoint = new Point();
        _this._vertexConstantData = new Float32Array([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]);
        return _this;
    }
    Object.defineProperty(Filter3DCopyPixelTask.prototype, "sourceTexture", {
        get: function () {
            return this._mainInputTexture;
        },
        set: function (value) {
            this._mainInputTexture = value;
        },
        enumerable: true,
        configurable: true
    });
    Filter3DCopyPixelTask.prototype.getVertexCode = function () {
        var temp1 = this._registerCache.getFreeVertexVectorTemp();
        var rect = this._registerCache.getFreeVertexConstant();
        var position = this._registerCache.getFreeVertexAttribute();
        this._positionIndex = position.index;
        var offset = this._registerCache.getFreeVertexConstant();
        var uv = this._registerCache.getFreeVertexAttribute();
        this._uvIndex = uv.index;
        this._uvVarying = this._registerCache.getFreeVarying();
        var code;
        code = "mul " + temp1 + ".xy, " + position + ", " + rect + ".zw\n" +
            "add " + temp1 + ".xy, " + temp1 + ", " + rect + ".xy\n" +
            "mov " + temp1 + ".w, " + position + ".w\n" +
            "mov op, " + temp1 + "\n" +
            "add " + this._uvVarying + ", " + uv + ", " + offset + ".xy\n";
        return code;
    };
    Filter3DCopyPixelTask.prototype.getFragmentCode = function () {
        var temp1 = this._registerCache.getFreeFragmentVectorTemp();
        var inputTexture = this._registerCache.getFreeTextureReg();
        this._inputTextureIndex = inputTexture.index;
        var code;
        code = "tex " + temp1 + ", " + this._uvVarying + ", " + inputTexture + " <2d,linear,clamp>\n" +
            "mov oc, " + temp1 + "\n";
        return code;
    };
    Filter3DCopyPixelTask.prototype.getMainInputTexture = function (stage) {
        return this._mainInputTexture;
    };
    Filter3DCopyPixelTask.prototype.activate = function (stage, projection, depthTexture) {
        var index = this._positionIndex;
        this._vertexConstantData[index] = (2 * this.destPoint.x + this.rect.width) / this._target.width - 1;
        this._vertexConstantData[index + 1] = (2 * this.destPoint.y + this.rect.height) / this._target.height - 1;
        this._vertexConstantData[index + 2] = this.rect.width / this._target.width;
        this._vertexConstantData[index + 3] = this.rect.height / this._target.height;
        this._vertexConstantData[index + 4] = this.rect.x / this._mainInputTexture.width;
        this._vertexConstantData[index + 5] = this.rect.y / this._mainInputTexture.height;
        var context = stage.context;
        context.setProgramConstantsFromArray(ContextGLProgramType.VERTEX, this._vertexConstantData);
    };
    Filter3DCopyPixelTask.prototype.deactivate = function (stage) {
    };
    return Filter3DCopyPixelTask;
}(Filter3DTaskBase));
export { Filter3DCopyPixelTask };
